/**
 * apps/web :: pages :: ChecklistsPage
 *
 * Placeholder learner-portal surface for the Checklists child of the
 * Courses nav group (ROADS nav restructure). Renders inside
 * `<LearnerPortalShell>` like the other informational learner pages. No
 * backend calls yet — the per-state checklist content lands in a later
 * ticket.
 */
import { useTranslation } from "react-i18next";

import LearnerPortalShell from "@/components/learner/LearnerPortalShell";

export default function ChecklistsPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <LearnerPortalShell pageTitle={t("checklists.title")}>
      <section className="mx-auto w-full max-w-3xl px-md pt-xl pb-xl sm:px-lg sm:pt-2xl sm:pb-2xl">
        <h1
          data-testid="checklists-heading"
          className="font-display text-2xl font-bold text-brand-primary sm:text-3xl"
        >
          {t("checklists.title")}
        </h1>
        <p className="mt-md text-neutral-700 sm:text-lg">
          {t("checklists.body")}
        </p>
      </section>
    </LearnerPortalShell>
  );
}
